@if (!initializationInProgress()) {
  <header
    procure-app-header
    [isEnvironmentBannerEnabled]="isEnvironmentBannerEnabled"
  ></header>
  <main
    #main
    class="main"
  >
    <nav procure-app-navigation></nav>
    <div class="content">
      @if (!isIframe()) {
        <router-outlet />
      }
    </div>
  </main>
  <procure-loading-indicator
    delay="long"
    [active]="isLoading()"
  />
  <procure-app-notifications />
} @else {
  <div
    class="loader"
    animate.enter="loader-enter"
    animate.leave="loader-leave"
  >
    <img
      class="loader-img"
      alt="Procure App Logo"
      [src]="'./assets/images/logo-procure-brand.svg' | fileHash"
    />
  </div>
}
